import React from 'react';
import { Button } from './ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from './ui/dropdown-menu';
import { Navigation, ExternalLink } from 'lucide-react';
import { t } from '../lib/i18n';

export const DirectionsButton = ({ address, lang = 'en', resourceId }) => {
  if (!address) return null;
  const encoded = encodeURIComponent(address);
  const options = [
    { key: 'google-maps', name: 'Google Maps', url: `https://www.google.com/maps/dir/?api=1&destination=${encoded}` },
    { key: 'apple-maps', name: 'Apple Maps', url: `https://maps.apple.com/?daddr=${encoded}` },
    { key: 'mbta', name: 'MBTA Trip Planner', url: `https://www.mbta.com/trip-planner/to/${encoded}` }
  ];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="sm" data-testid={`directions-btn-${resourceId}`}
          className="no-print rounded-full bg-[#5C4023] hover:bg-[#4A331C] text-white h-8 px-3 text-xs">
          <Navigation className="w-3.5 h-3.5 mr-1.5" />{t('directions', lang)}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="rounded-xl bg-white border-[#E0D6C8]">
        {options.map((o) => (
          <DropdownMenuItem key={o.key} data-testid={`directions-${o.key}-${resourceId}`}
            onClick={() => window.open(o.url, '_blank', 'noopener')} className="cursor-pointer text-sm">
            <ExternalLink className="w-3.5 h-3.5 mr-2 text-[#C87D3E]" />{o.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
